<div class="modal-container">
  <div class="modal-header">
    <h3 class="mat-h3">Add new source</h3>
  </div>

  <div class="modal-content">
    <form class="form-field-full" [formGroup]="newSourceForm">
      <div class="form-inputs">
        <mat-form-field class="gingr-input-wrapper w-full">
          <input matInput placeholder="Source name" type="text" formControlName="name" required />
          @if (name.invalid) {
            <mat-error>
              @if (name.errors?.required) {
                <span>Please enter source name </span>
              }
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field class="gingr-input-wrapper w-full">
          <mat-select formControlName="status" placeholder="Select status">
            @for (st of statuses; track st) {
              <mat-option [value]="st">
                {{ st | titlecase }}
              </mat-option>
            }
          </mat-select>
          @if (status.invalid) {
            <mat-error>
              @if (status.errors?.required) {
                <span>Please provide status </span>
              }
            </mat-error>
          }
        </mat-form-field>

        <div class="gingr-content">
          <mat-form-field class="gingr-input-wrapper w-full">
            <input
              formControlName="publicationDate"
              matInput
              [matDatepicker]="picker"
              placeholder="Choose a date"
              />
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>

        <mat-form-field class="gingr-input-wrapper w-full">
          <input matInput placeholder="Source" type="text" formControlName="source" />
        </mat-form-field>

        <mat-form-field class="gingr-input-wrapper w-full">
          <textarea matInput class="" placeholder="Content" formControlName="content"> </textarea>
        </mat-form-field>

        <mat-form-field class="gingr-input-wrapper w-full">
          <textarea matInput class="" placeholder="References" formControlName="references">
          </textarea>
        </mat-form-field>

        <mat-form-field class="gingr-input-wrapper w-full">
          <mat-select placeholder="Select country" formControlName="countries" multiple>
            @for (value of getCountriesAndRegions(); track value; let i = $index) {
              <mat-option
                [value]="value._id"
                >
                {{ value.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field class="gingr-input-wrapper w-full">
          <mat-select formControlName="priority" placeholder="Select a priority level">
            @for (val of [1, 2, 3, 4, 5]; track val) {
              <mat-option [value]="val">
                {{ getPriorityLabel(val) }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <app-drag-drop (handleFileUpload)="onFileUpload($event)"></app-drag-drop>
      </div>

      <div class="d-flex justify-content-center">
        @if (isLoading) {
          <mat-progress-spinner
            class="spinner"
            [color]="'accent'"
            [mode]="'indeterminate'"
            [value]="50"
            >
          </mat-progress-spinner>
        }
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button
      mat-raised-button
      color="accent"
      [disabled]="newSourceForm.invalid || isLoading"
      (click)="addNewItem()"
      >
      Add new source
    </button>
    <button mat-button mat-dialog-close>Close</button>
  </div>
</div>
